module.exports = __webpack_public_path__ + "static/media/ic_code_homepage.64acc892.png";